import React from 'react';
import MLButton from '../../../../../../components/MLButton';
import MLIcon from '../../../../../../components/MLIcon/MLIcon';
import styles from './EmptySRLDashboard.module.css';

import SRLDemoGraphOne from './SRLDemoGraphOne.png';
import SRLDemoGraphTwo from './SRLDemoGraphTwo.png';
import SRLDemoResponseOne from './SRLDemoResponseOne.png';
import SRLDemoResponseTwo from './SRLDemoResponseTwo.png';

function EmptySRLDashboard() {
  return (
    <div className={styles.emptyHelpContainer}>
      <div className={styles.emptyHelpLeftSide}>
        <h2 className={styles.emptyHelpTitle}>
          Help students master their own learning.
        </h2>
        <div className={styles.emptyHelpDescription}>
          <p>
            Achieve is offering a series of new surveys (1 Intro and 4 Checkpoints) designed to have your students:
          </p>
          <ul>
            <li>
              Set goals for themselves
            </li>
            <li>
              Reflect on their progress
            </li>
            <li>
              Determine actions they can take to reach their goals
            </li>
            <li>
              Develop effective learning strategies
            </li>
          </ul>
          <p>
            As the instructor you will receive insights that can help you target interventions and support based on your students’ responses.
          </p>
          <p>
            You can find the surveys in
            <MLIcon
              className={styles.folderIcon}
              type="folder"
              role="presentation"
            />
            <span className={styles.grayText}> Resources </span>
            or in a pre-built Course Template under the folder title:
            <span className={styles.boldText}> Goal-setting and Reflection Surveys. </span>
          </p>
        </div>
        <div className={styles.emptyHelpButtonContainer}>
          <MLButton
            className={styles.emptyHelpButton}
            btnType="secondary"
            btnText="Learn More"
            testId="btn_learn_more"
            onClick={() => window.open('https://mhe.my.site.com/macmillanlearning/s/article/Achieve-Introduction-to-Goal-setting-and-Reflection-Surveys', '_blank')}
          />
        </div>
      </div>
      <div className={styles.emptyHelpRightSide}>
        <img src={SRLDemoGraphOne} alt="Bar chart showing student time spent outside of class with 9.4 hours class median. Question: How much time are students spending outside of class? Chart shows distribution across time ranges, with Sundays having highest activity at 2 hour average." />
        <img src={SRLDemoGraphTwo} alt="Progress tracking chart showing 49% of students are off track towards their goals. Displays split between off track and on track students, with example response: 'To get back on track I plan to do the whole homework of the week in one sitting, study daily and attend the tutor sessions daily as well.'" />
        <img src={SRLDemoResponseOne} alt="Testimonial from Katelyn Cottone, Chemistry Faculty at Oakland Community College: 'I was shocked to see that only 4 students out of 53 on the second survey said that I caused them to do poorly! That is amazing. What a huge difference in training them to have a growth mindset and to give them the tools to know that learning is within their power.'" />
        <img src={SRLDemoResponseTwo} alt="Testimonial from Psychology Student at University of Indianapolis: 'The surveys helped me stay accountable for how I was approaching the class and helped me develop overall as a student.'" />
      </div>
    </div>
  );
}

export default EmptySRLDashboard;
